(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global['@zola-helpers/client'] = {}));
}(this, (function (exports) { 'use strict';

  var LOCAL_STORAGE_SUPPORT = Boolean(window.localStorage);
  var SESSION_STORAGE_SUPPORT = Boolean(window.sessionStorage);
  /**
   * set a cookie
   * @param {string}  key - cookie key
   * @param {string}  value - cookie value
   * @param {boolean} durationDays - expiration date
   */

  function setCookie(key, value, durationDays) {
    var cookieString = "".concat(key, "=").concat(value);

    if (durationDays) {
      var d = new Date();
      d.setTime(d.getTime() + durationDays * 24 * 3600 * 1000);
      cookieString += "; expires=".concat(d.toUTCString());
    }

    document.cookie = "".concat(cookieString, "; path=/");
  }
  /**
   * get a cookie
   * @param {string}  key - name of cookie to retrieve
   * @returns {string}
   */

  function getCookie(key) {
    var name = "".concat(key, "=");
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i += 1) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }
  /**
   * delete a cookie
   * @param {string}  key - name of cookie
   */

  function deleteCookie(key) {
    setCookie(key, '', -1);
  }
  /**
   * get a value from localStorage
   * @param {string}  key - name of property to retrieve
   * @returns {string}
   */

  function getLocalStorage(key) {
    if (LOCAL_STORAGE_SUPPORT) {
      return window.localStorage.getItem(key);
    }

    return getCookie(key);
  }
  /**
   * set a value in localStorage
   * @param {string}  key - name of property
   * @param {string}  value - value of property
   */

  function setLocalStorage(key, value) {
    if (LOCAL_STORAGE_SUPPORT) {
      window.localStorage.setItem(key, value);
    } else {
      setCookie(key, value, 365);
    }
  }
  /**
   * remove a value in localStorage
   * @param {string}  key - name of property
   */

  function deleteLocalStorage(key) {
    if (LOCAL_STORAGE_SUPPORT) {
      window.localStorage.removeItem(key);
    } else {
      deleteCookie(key);
    }
  }
  /**
   * set a value in sessionStorage
   * @param {string}  key - name of property
   * @param {string}  value - value of property
   */

  function setSessionStorage(key, value) {
    if (SESSION_STORAGE_SUPPORT) {
      window.sessionStorage.setItem(key, value);
    } else {
      setCookie(key, value);
    }
  }
  /**
   * get a value from sessionStorage
   * @param {string}  key - name of property to retrieve
   * @returns {string}
   */

  function getSessionStorage(key) {
    if (SESSION_STORAGE_SUPPORT) {
      return window.sessionStorage.getItem(key);
    }

    return getCookie(key);
  }
  /**
   * remove a value in sessionStorage
   * @param {string}  key - name of property
   */

  function deleteSessionStorage(key) {
    if (SESSION_STORAGE_SUPPORT) {
      window.sessionStorage.removeItem(key);
    } else {
      deleteCookie(key);
    }
  }
  function setAllStorage(key, value) {
    setCookie(key, value);
    setLocalStorage(key, value);
  }
  function getAllStorage(key) {
    var cookieValue = getCookie(key);
    var localStorageValue = getLocalStorage(key);

    if (cookieValue) {
      return cookieValue;
    }

    if (localStorageValue) {
      return localStorageValue;
    }

    return null;
  }

  /**
   * check if user is in an Optimizely experiment
   * @param {Object} optimizelyConfig - Object containing two properties, the staging and production IDs from Optimizely
   * @param {Object} optimizelyConfig.554664308 - staging
   * @param {Object} optimizelyConfig.566520915 - production
   * @param {string} optimizelyConfig.554664308.pageName - provided in Optimizely, specific to the experiment
   * @param {string} optimizelyConfig.554664308.experimentId - provided in Optimizely, specific to the experiment
   * @param {string} optimizelyConfig.554664308.variationId - provided in Optimizely, specific to the experiment
   * @param {boolean} [triggerExperiment=false] - indicate if you would like manually trigger the Optimizely Experiment
   * @returns {boolean}
   * @example optimizelyConfig
   * {
      // Staging
      554664308: {
        pageName: '554664308_url_targeting_for_perfect_registry_onboarding',
        experimentId: '12109791999',
        variationId: '12091993637'
      },
      // Production
      566520915: {
        pageName: '566520915_url_targeting_for_perfect_registry_onboarding',
        experimentId: '12115484653',
        variationId: '12119022586'
      }
   * };
   */
  // ************ DEPRICATED *******************  Please use the other helper methods.

  function inOptimizelyExperiment(optimizelyConfig) {
    var triggerExperiment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // Skip for bots
    var automatedTest = getCookie('automatedTest');

    if (automatedTest) {
      return false;
    } // Check if optimizely installed


    if (window.optimizely && window.optimizely.get) {
      var optimizelyData = window.optimizely.get('data');
      var _optimizelyConfig$opt = optimizelyConfig[optimizelyData.projectId],
          pageName = _optimizelyConfig$opt.pageName,
          experimentId = _optimizelyConfig$opt.experimentId,
          variationId = _optimizelyConfig$opt.variationId;
      /*
        This is important! Since we're manually triggering when a user should be placed in the experiment,
        it is the developer's responsibility to indicate that the user should be included using this param.
        Otherwise, we run the risk of placing users in experiments incorrectly.
        You can call the inOptimizelyExperiment as many times as needed, but in most circumstances,
        you should only trigger experiment once.
      */

      if (triggerExperiment) {
        window.optimizely = window.optimizely || [];
        window.optimizely.push({
          type: 'page',
          pageName: pageName
        });
      }

      var state = window.optimizely.get('state');
      var allExperiments = state.getExperimentStates({
        isActive: true
      });
      var experiment = allExperiments[experimentId]; // We're only returning true here if the user has been placed in the experiment AND the variation
      // They could be in the experiment, but receive the Original variant, resulting in false

      if (experiment && experiment.variation && experiment.variation.id === variationId) {
        return true;
      }
    }

    return false;
  } // Returns the optimizely variation id for a given experiment, undefined if not in the experiment.

  /**
   * get query param by name
   * @param {string}  paramName - name of parameter to retrieve
   * @param {boolean} trimValue - should trim string value
   * @returns {string}
   */
  function getQueryParam(paramName) {
    var trimValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var queryString = window.location.search.trim();

    if (queryString.length > 1) {
      var queryStringParts = queryString.substring(1).split('&');

      for (var i = 0; i < queryStringParts.length; i += 1) {
        var partPair = queryStringParts[i].split('=');

        if (partPair[0] === paramName) {
          var paramValue = decodeURIComponent(partPair[1]);
          return trimValue ? paramValue.trim() : paramValue;
        }
      }
    }

    return '';
  }

  var defaultNegative = function defaultNegative() {
    return null;
  };
  /**
   * util for rendering jsx if conditional is met
   * @param {boolean} conditional - conditional to evaluate
   * @param {function} affirmative - function to execute if conditional === true
   * @param {function} negative - function to execute if conditional === false
   */


  function renderIf(conditional, affirmative) {
    var negative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultNegative;
    return conditional ? affirmative() : negative();
  }

  var BUSINESS_UNIT = {
    WEDDINGS: 'WEDDINGS',
    WEDDING_REGISTRY: 'WEDDING_REGISTRY',
    INSPIRATION: 'INSPIRATION',
    MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
    MARKETPLACE_VENDORS: 'MARKETPLACE_VENDORS',
    INVITATIONS: 'INVITATIONS'
  };
  var COMPONENT = {
    REGISTRY: 'REGISTRY',
    WEDDINGS: 'WEDDINGS',
    WEDDING_WEBSITE: 'WEDDING_WEBSITE',
    WEDDING_CHECKLIST: 'WEDDING_CHECKLIST',
    WEDDING_GUEST_LIST: 'WEDDING_GUEST_LIST',
    WEDDING_PLANNING: 'WEDDING_PLANNING',
    INSPIRATION: 'INSPIRATION',
    REAL_WEDDINGS: 'REAL_WEDDINGS',
    MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
    MARKETPLACE_MATCH: 'MARKETPLACE_MATCH',
    VENUE: 'VENUE',
    PHOTOGRAPHER: 'PHOTOGRAPHER',
    INVITATIONS: 'INVITATIONS',
    SAVE_THE_DATE: 'SAVE_THE_DATE',
    DAY_OF_PAPER: 'DAY_OF_PAPER',
    THANK_YOU_CARDS: 'THANK_YOU_CARDS',
    HOLIDAY: 'HOLIDAY'
  };
  var onboardTrackingConstants = {
    BUSINESS_UNIT: BUSINESS_UNIT,
    COMPONENT: COMPONENT
  };

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var _global = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
  });

  var _core = createCommonjsModule(function (module) {
  var core = module.exports = { version: '2.6.10' };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
  });
  var _core_1 = _core.version;

  var _aFunction = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };

  // optional / simple context binding

  var _ctx = function (fn, that, length) {
    _aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 1: return function (a) {
        return fn.call(that, a);
      };
      case 2: return function (a, b) {
        return fn.call(that, a, b);
      };
      case 3: return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
    }
    return function (/* ...args */) {
      return fn.apply(that, arguments);
    };
  };

  var _isObject = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  var _anObject = function (it) {
    if (!_isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };

  var _fails = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };

  // Thank's IE8 for his funny defineProperty
  var _descriptors = !_fails(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
  });

  var document$1 = _global.document;
  // typeof document.createElement is 'object' in old IE
  var is = _isObject(document$1) && _isObject(document$1.createElement);
  var _domCreate = function (it) {
    return is ? document$1.createElement(it) : {};
  };

  var _ie8DomDefine = !_descriptors && !_fails(function () {
    return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
  });

  // 7.1.1 ToPrimitive(input [, PreferredType])

  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  var _toPrimitive = function (it, S) {
    if (!_isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var dP = Object.defineProperty;

  var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    _anObject(O);
    P = _toPrimitive(P, true);
    _anObject(Attributes);
    if (_ie8DomDefine) try {
      return dP(O, P, Attributes);
    } catch (e) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };

  var _objectDp = {
  	f: f
  };

  var _propertyDesc = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  var _hide = _descriptors ? function (object, key, value) {
    return _objectDp.f(object, key, _propertyDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  var hasOwnProperty = {}.hasOwnProperty;
  var _has = function (it, key) {
    return hasOwnProperty.call(it, key);
  };

  var PROTOTYPE = 'prototype';

  var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      if (own && _has(exports, key)) continue;
      // export native or passed
      out = own ? target[key] : source[key];
      // prevent global pollution for namespaces
      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
      // bind timers to global for call from export context
      : IS_BIND && own ? _ctx(out, _global)
      // wrap global constructors for prevent change them in library
      : IS_WRAP && target[key] == out ? (function (C) {
        var F = function (a, b, c) {
          if (this instanceof C) {
            switch (arguments.length) {
              case 0: return new C();
              case 1: return new C(a);
              case 2: return new C(a, b);
            } return new C(a, b, c);
          } return C.apply(this, arguments);
        };
        F[PROTOTYPE] = C[PROTOTYPE];
        return F;
      // make static versions for prototype methods
      })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
      // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
      if (IS_PROTO) {
        (exports.virtual || (exports.virtual = {}))[key] = out;
        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
        if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
      }
    }
  };
  // type bitmap
  $export.F = 1;   // forced
  $export.G = 2;   // global
  $export.S = 4;   // static
  $export.P = 8;   // proto
  $export.B = 16;  // bind
  $export.W = 32;  // wrap
  $export.U = 64;  // safe
  $export.R = 128; // real proto method for `library`
  var _export = $export;

  var toString = {}.toString;

  var _cof = function (it) {
    return toString.call(it).slice(8, -1);
  };

  // fallback for non-array-like ES3 and non-enumerable old V8 strings

  // eslint-disable-next-line no-prototype-builtins
  var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return _cof(it) == 'String' ? it.split('') : Object(it);
  };

  // 7.2.1 RequireObjectCoercible(argument)
  var _defined = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };

  // to indexed object, toObject with fallback for non-array-like ES3 strings


  var _toIobject = function (it) {
    return _iobject(_defined(it));
  };

  // 7.1.4 ToInteger
  var ceil = Math.ceil;
  var floor = Math.floor;
  var _toInteger = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };

  // 7.1.15 ToLength

  var min = Math.min;
  var _toLength = function (it) {
    return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };

  var max = Math.max;
  var min$1 = Math.min;
  var _toAbsoluteIndex = function (index, length) {
    index = _toInteger(index);
    return index < 0 ? max(index + length, 0) : min$1(index, length);
  };

  // false -> Array#indexOf
  // true  -> Array#includes



  var _arrayIncludes = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = _toIobject($this);
      var length = _toLength(O.length);
      var index = _toAbsoluteIndex(fromIndex, length);
      var value;
      // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
      } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      } return !IS_INCLUDES && -1;
    };
  };

  var _shared = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global[SHARED] || (_global[SHARED] = {});

  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core.version,
    mode:  'pure' ,
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
  });

  var id = 0;
  var px = Math.random();
  var _uid = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };

  var shared = _shared('keys');

  var _sharedKey = function (key) {
    return shared[key] || (shared[key] = _uid(key));
  };

  var arrayIndexOf = _arrayIncludes(false);
  var IE_PROTO = _sharedKey('IE_PROTO');

  var _objectKeysInternal = function (object, names) {
    var O = _toIobject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i) if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  // IE 8- don't enum bug keys
  var _enumBugKeys = (
    'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
  ).split(',');

  // 19.1.2.14 / 15.2.3.14 Object.keys(O)



  var _objectKeys = Object.keys || function keys(O) {
    return _objectKeysInternal(O, _enumBugKeys);
  };

  var f$1 = Object.getOwnPropertySymbols;

  var _objectGops = {
  	f: f$1
  };

  var f$2 = {}.propertyIsEnumerable;

  var _objectPie = {
  	f: f$2
  };

  // 7.1.13 ToObject(argument)

  var _toObject = function (it) {
    return Object(_defined(it));
  };

  // 19.1.2.1 Object.assign(target, source, ...)






  var $assign = Object.assign;

  // should work with symbols and should have deterministic property order (V8 bug)
  var _objectAssign = !$assign || _fails(function () {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) { B[k] = k; });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source) { // eslint-disable-line no-unused-vars
    var T = _toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = _objectGops.f;
    var isEnum = _objectPie.f;
    while (aLen > index) {
      var S = _iobject(arguments[index++]);
      var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
      var length = keys.length;
      var j = 0;
      var key;
      while (length > j) {
        key = keys[j++];
        if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
      }
    } return T;
  } : $assign;

  // 19.1.3.1 Object.assign(target, source)


  _export(_export.S + _export.F, 'Object', { assign: _objectAssign });

  var assign = _core.Object.assign;

  var assign$1 = assign;

  function getPageContext() {
    return {
      path: window.location.pathname,
      search: window.location.search,
      referrer: window && window.zola && window.zola.referrer || document.referrer,
      url: window.location.href,
      title: document.title
    };
  }

  function trackEvent(eventName, payload, options) {
    var optionsFinal = options || {};
    optionsFinal.page = getPageContext();

    if (window.analytics && window.analytics.track) {
      window.analytics.track(eventName, payload, optionsFinal);
    }
  }
  function trackGoogleAnalyticsEvent(eventName, payload) {
    var options = {
      integrations: {
        All: false,
        'Google Analytics': true
      }
    };
    trackEvent(eventName, payload, options);
  }
  function trackOptimizelyEvent(eventName) {
    window.optimizely = window.optimizely || [];
    window.optimizely.push({
      type: 'event',
      eventName: eventName
    });
  }

  function mapOnboardingEventsToOptimizelyMetrics(businessUnit, component) {
    // Event names convert to optimizely experiment metrics.
    // Metric names must match the event names exactly.
    // Only fires when certain experiment conditions are met: https://segment.com/docs/destinations/optimizely-web/#track
    if (businessUnit === BUSINESS_UNIT.WEDDING_REGISTRY && component === COMPONENT.REGISTRY) {
      trackOptimizelyEvent('Onboarding Completed - Registry');
    } else if (businessUnit === BUSINESS_UNIT.INVITATIONS && component === COMPONENT.SAVE_THE_DATE) {
      trackOptimizelyEvent('Onboarding Completed - STD');
    } else if (businessUnit === BUSINESS_UNIT.INVITATIONS && component === COMPONENT.INVITATIONS) {
      trackOptimizelyEvent('Onboarding Completed - Invitations');
    } else if (businessUnit === BUSINESS_UNIT.WEDDINGS && component === COMPONENT.WEDDINGS) {
      trackOptimizelyEvent('Onboarding Completed - Weddings');
    } else if (businessUnit === BUSINESS_UNIT.WEDDINGS && component === COMPONENT.WEDDING_WEBSITE) {
      trackOptimizelyEvent('Onboarding Completed - Weddings - Component - Website');
    } else if (businessUnit === BUSINESS_UNIT.WEDDINGS && component === COMPONENT.WEDDING_CHECKLIST) {
      trackOptimizelyEvent('Onboarding Completed - Checklist');
    } else if (businessUnit === BUSINESS_UNIT.WEDDINGS && component === COMPONENT.WEDDING_GUEST_LIST) {
      trackOptimizelyEvent('Onboarding Completed - Guest List');
    } // Per MAS-436: Catch all "Paper" products and send another event


    if (businessUnit === BUSINESS_UNIT.INVITATIONS) {
      trackOptimizelyEvent('Onboarding Completed - Paper');
    }
  }

  /*
    This file contains events from the Zola Web Analytics tracking plan related to onboarding:
    'Onboarding Started' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1706975390
    'Onboarding Completed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=533789771
    'Onboarding Step Viewed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=522474832
    'Onboarding Step Completed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=686083819
    'Onboarding Step Skipped' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1573913863
  */

  function trackOnboardingStarted(businessUnit, component) {
    var isExistingUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    // isExistingUser used by some tags in GTM
    if (window.analytics && window.dataLayer) {
      window.dataLayer.push({
        is_existing_user: isExistingUser
      });
    }

    var payload = {
      business_unit: businessUnit,
      component: component
    };
    trackEvent('Onboarding Started', payload);
  }
  function trackOnboardingCompleted(businessUnit, component) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var defaultOptions = {
      isExistingUser: null,
      // Boolean value
      weddingDate: null // Should be 'YYYY-MM-DD' format.

    };

    var combinedOptions = assign$1({}, defaultOptions, options);

    var isExistingUser = combinedOptions.isExistingUser,
        weddingDate = combinedOptions.weddingDate; // let { weddingDate } = combinedOptions;
    // Impact Radius should only receive Registry First Onboarding Completed events

    var registryFirst = businessUnit === 'WEDDING_REGISTRY' && !isExistingUser;
    var clickId = getAllStorage('clickId');
    var trackEventOptions = {
      integrations: {
        'Impact Radius': false
      }
    };

    if (clickId && registryFirst) {
      trackEventOptions.context = {
        referrer: {
          type: 'impactRadius',
          id: clickId
        }
      };
      trackEventOptions.integrations['Impact Radius'] = true;
    } // TODO: Decide if the moment.js library should exist in zola-helpers. Date param must be formatted correctly when passed in.
    // if (weddingDate) weddingDate = moment(weddingDate).format('YYYY-MM-DD');


    if (window.analytics && window.dataLayer) {
      window.dataLayer.push({
        is_existing_user: isExistingUser,
        wedding_date: weddingDate
      });
    }

    var payload = {
      business_unit: businessUnit,
      component: component
    }; // Optimizely cannot read event properties easily, so we have to customized the event name.

    mapOnboardingEventsToOptimizelyMetrics(businessUnit, component);
    trackEvent('Onboarding Completed', payload, trackEventOptions);
  }
  function trackOnboardingStepCompleted(businessUnit, component, stepKey, stepName, questionnaireVersion) {
    var payload = {
      business_unit: businessUnit,
      component: component,
      step_key: stepKey,
      step_name: stepName,
      questionnaire_version: questionnaireVersion
    };
    trackEvent('Onboarding Step Completed', payload);
  }
  function trackOnboardingStepViewed(businessUnit, component, stepKey, stepName, questionnaireVersion) {
    var payload = {
      business_unit: businessUnit,
      component: component,
      step_key: stepKey,
      step_name: stepName,
      questionnaire_version: questionnaireVersion
    };
    trackEvent('Onboarding Step Viewed', payload);
  }
  function trackOnboardingStepSkipped(businessUnit, component, stepKey, stepName, questionnaireVersion) {
    var payload = {
      business_unit: businessUnit,
      component: component,
      step_key: stepKey,
      step_name: stepName,
      questionnaire_version: questionnaireVersion
    };
    trackEvent('Onboarding Step Skipped', payload);
  }

  // most Object methods by ES6 should accept primitives



  var _objectSap = function (KEY, exec) {
    var fn = (_core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
  };

  // 19.1.2.14 Object.keys(O)



  _objectSap('keys', function () {
    return function keys(it) {
      return _objectKeys(_toObject(it));
    };
  });

  var keys = _core.Object.keys;

  var keys$1 = keys;

  /**
   * Load JavaScript from source
   * This helper comes from htmlScriptLoader.jsx in web-registry
   * src is a String, attributes is an Object
   * @param src
   * @param attributes
   */
  function loadSrc(src, attributes) {
    var script = document.createElement('script');
    script.src = src;
    script.async = false;

    if (attributes) {
      var keys = keys$1(attributes);

      keys.forEach(function (key) {
        var value = attributes[key];
        script.setAttribute(key, value);
      });
    }

    document.body.appendChild(script);
  }

  function pushToDataLayer(payload) {
    if (window.analytics && window.dataLayer) {
      window.dataLayer.push(payload);
    }
  }

  function setGTMLoggedIn() {
    pushToDataLayer({
      LoginStatus: 'Logged In'
    });
  }
  function setGTMLoggedOut() {
    pushToDataLayer({
      LoginStatus: 'Not Logged In'
    });
  }

  /*
    This file contains events from the Zola Web Analytics tracking plan related to shop products:
    'Product Added': https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=164175519
  */

  function trackProductAdded(eventData) {
    if (!eventData) {
      // eslint-disable-next-line no-console
      console.warn('Product Added event called with falsy value.');
      return;
    } // eslint-disable-next-line no-console


    if (keys$1(eventData).length === 0) console.warn('Product Added event called without properties.'); // if the brand is not defined - clear it on the GTM data layer becuase we check for it to determine if the product added is a cash gift.

    if (!eventData.brand && window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push({
        brand: undefined
      });
    }

    trackEvent('Product Added', eventData);
  }

  exports.deleteCookie = deleteCookie;
  exports.deleteLocalStorage = deleteLocalStorage;
  exports.deleteSessionStorage = deleteSessionStorage;
  exports.getAllStorage = getAllStorage;
  exports.getCookie = getCookie;
  exports.getLocalStorage = getLocalStorage;
  exports.getQueryParam = getQueryParam;
  exports.getSessionStorage = getSessionStorage;
  exports.inOptimizelyExperiment = inOptimizelyExperiment;
  exports.loadSrc = loadSrc;
  exports.onboardTrackingConstants = onboardTrackingConstants;
  exports.renderIf = renderIf;
  exports.setAllStorage = setAllStorage;
  exports.setCookie = setCookie;
  exports.setGTMLoggedIn = setGTMLoggedIn;
  exports.setGTMLoggedOut = setGTMLoggedOut;
  exports.setLocalStorage = setLocalStorage;
  exports.setSessionStorage = setSessionStorage;
  exports.trackEvent = trackEvent;
  exports.trackGoogleAnalyticsEvent = trackGoogleAnalyticsEvent;
  exports.trackOnboardingCompleted = trackOnboardingCompleted;
  exports.trackOnboardingStarted = trackOnboardingStarted;
  exports.trackOnboardingStepCompleted = trackOnboardingStepCompleted;
  exports.trackOnboardingStepSkipped = trackOnboardingStepSkipped;
  exports.trackOnboardingStepViewed = trackOnboardingStepViewed;
  exports.trackOptimizelyEvent = trackOptimizelyEvent;
  exports.trackProductAdded = trackProductAdded;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=zola-helpers-client.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola-helpers/client/dist/umd/zola-helpers-client.js
// module id = 44
// module chunks = 53